export const environment = {
  production: false,
  devModeDisableGlobalPolling: false,
  InterceptorSkipHeader: 'X-Skip-Interceptor',
  meteoblueWindUrl: 'https://www.meteoblue.com/en/weather/maps/widget/',
  what3wordsUri: 'https://api.what3words.com/v3/convert-to-3wa',
  dynamoUserSessionsUri: 'https://naaz22s7ng.execute-api.eu-west-2.amazonaws.com/live/user-sessions?table=UserSessionTest',

  sourceUrl: 'https://admin.testing.skylarkcontrol.com',
  apiUrl: 'https://api.testing.skylarkcontrol.com/',
  competencyApiUrl: 'https://comp-api.testing.skylarkcontrol.com/',

  privacyUrl: 'https://admin.skylarkcontrol.com/legal/terms-of-service.html',

  customMapStyle: [],
  credentialsExpiryHours: 12,
  competencySoonToExpireDays: 6,
  keys: {
    accessToken: 'skylark_token',
    username: 'skylark_u',
    password: 'skylark_p',
    credentialsExpiry: 'skylark_e',
    changePasswordRequired: 'skylark_c_p_r',
    what3words: 'w3w',
    dynamoUserSessions: 'dynamoUS',

  },
  pageSizes: [25, 50, 100],
  perPageOptionsSmall: [5, 10, 20],
  //HUNTSTOWN_ID: 144, change to prod value for duration of clone test
  HUNTSTOWN_ID: 169,
  //SSE_OWNER_SKYLARK_ID: 2408, change to prod value for duration of clone test
  SSE_OWNER_SKYLARK_ID: 17165,
  SSE_SITE_OWNER_NAME: 'Lochside Wind Energy Ltd',
  VENTUS_OWNER_SKYLARK_ID: 0,
  WFSO_OWNER_SKYLARK_ID: 2780,
  CONTRACTOR_MANAGER_INVITE_BLOCKED_SITE_OWNER_IDS: [17165, 2780, 0],
  WFSO_FILTERED_COMPETENCIES: [1001,1002,1003,1004,1005,1006,2001,2002,2003,3001,3002,4009,4011,4012,4013,4014,4015,4016,4025,4026,4027,4036,4037,4039,4041,4047,4048,4049,4052,4053,4054,4055,4056,4058,4059,4060,4062,4063,4064,4065,4066,4067,4073,4074,4075,4076,4077,4078,4081,4085,4087,4088,4119,4120,4121,4124,4125,4126,4130,4132,4136,4141,4142,4324],
  CONTRACTOR_COMPETENCY_ID_TO_EXTRA_INFO_TEXT: {
    5020: 'minimum cover permitted EUR 13 million', // EMPLOYERS_LIABILITY_INSURANCE_ID
    5021: 'minimum cover permitted EUR 6.5 million', // PUBLIC_AND_PRODUCTS_LIABILITY_INSURANCE_ID
    5019: 'must be submitted in English', // SAFETY_STATEMENT_ID
  },
};
